import React from 'react'
import { Alert, Stack, Typography } from '@mui/material'
import TelegramForm from '../../components/integrations/TelegramForm'
import { useSettingsIntegrations } from '../Settings'

const TelegramIntegration: React.FC = () => {
  const { stationId, providers, loading, error, refreshProviders, notify } = useSettingsIntegrations()
  const provider = providers['telegram']

  if (!stationId) {
    return <Alert severity="info">Select a station to manage integrations.</Alert>
  }

  return (
    <Stack spacing={2.5}>
      <Stack spacing={0.5}>
        <Typography variant="h5" component="h2">
          Telegram
        </Typography>
        <Typography color="text.secondary">
          Connect your Telegram bot token, set the webhook, and start ingesting listener messages instantly.
        </Typography>
      </Stack>

      {error ? <Alert severity="error">{error}</Alert> : null}

      <TelegramForm
        stationId={stationId}
        provider={provider}
        initializing={loading && !provider}
        onSaved={refreshProviders}
        onNotify={notify}
      />
    </Stack>
  )
}

export default TelegramIntegration
